// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.page-header {
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  padding-top: 2rem;
  margin-bottom: 3.5rem;
}
.page-header h1 {
  margin: 0;
}
.page-header .back-arrow {
  position: absolute;
  left: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  color: #04abbd;
  text-decoration: none;
  font-size: 18px;
  border-radius: 4px;
  transition: background 0.2s, color 0.2s;
}
.page-header .back-arrow:hover {
  background: rgba(4, 171, 189, 0.1);
  color: #03929e;
  text-decoration: none;
}
.page-header .back-arrow i {
  font-size: 18px;
}`, "",{"version":3,"sources":["webpack://./src/app/argic/view/infodownload/infodownload.component.scss"],"names":[],"mappings":"AAAA;EACI,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;EACA,iBAAA;EACA,qBAAA;AACJ;AACI;EACI,SAAA;AACR;AAEI;EACI,kBAAA;EACA,OAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,YAAA;EACA,cAAA;EACA,qBAAA;EACA,eAAA;EACA,kBAAA;EACA,uCAAA;AAAR;AAEQ;EACI,kCAAA;EACA,cAAA;EACA,qBAAA;AAAZ;AAGQ;EACI,eAAA;AADZ","sourcesContent":[".page-header {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    position: relative;\n    padding-top: 2rem;\n    margin-bottom: 3.5rem;\n\n    h1 {\n        margin: 0;\n    }\n\n    .back-arrow {\n        position: absolute;\n        left: 0;\n        display: flex;\n        align-items: center;\n        justify-content: center;\n        width: 40px;\n        height: 40px;\n        color: #04abbd;\n        text-decoration: none;\n        font-size: 18px;\n        border-radius: 4px;\n        transition: background 0.2s, color 0.2s;\n\n        &:hover {\n            background: rgba(4, 171, 189, 0.1);\n            color: #03929e;\n            text-decoration: none;\n        }\n\n        i {\n            font-size: 18px;\n        }\n    }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
